import { Alert } from "@mui/material"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"

import { StyledButton } from "components/Button/StyledButton"
import { ResponsiveDialog } from "components/ResponsiveDialog/ResponsiveDialog"
import { DeviceSetup, Examination, TaskStep, TestData } from "graphql/types"
import { getTextForTaskStep } from "utils/taskSteps"
import { TaskStepSwitch } from "./TaskStepSwitch"

type DataInputDialogProps = {
  open: boolean
  onClose: () => void
  addData: () => void
  testData: TestData | undefined
  setTestData: React.Dispatch<React.SetStateAction<TestData>>
  deviceSetup: DeviceSetup[]
  setDeviceSetup: React.Dispatch<React.SetStateAction<DeviceSetup[]>>
  examination: Examination | undefined
  setExamination: React.Dispatch<React.SetStateAction<Examination | undefined>>
}

export const DataInputDialog = (props: DataInputDialogProps) => {
  const {
    open,
    onClose,
    addData,
    testData,
    setTestData,
    deviceSetup,
    setDeviceSetup,
    examination,
    setExamination,
  } = props

  const handleClose = () => {
    onClose()
  }

  const handleAddData = () => {
    addData()
    handleClose()
  }

  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      {testData && <DialogTitle sx={{ px: 1 }}>{getTextForTaskStep(testData.type)}</DialogTitle>}
      <DialogContent
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        {testData && (testData.type === TaskStep.NOTE || testData.type === TaskStep.HELPER) && (
          <Alert severity="info" sx={{ mb: 1 }}>
            Klicken Sie auf "Speichern" um die Notiz zu sichern
          </Alert>
        )}
        {testData && (
          <TaskStepSwitch
            testData={testData}
            setTestData={setTestData}
            deviceSetup={deviceSetup}
            setDeviceSetup={setDeviceSetup}
            examination={examination}
            setExamination={setExamination}
          />
        )}
      </DialogContent>
      <DialogActions>
        <StyledButton buttonType="cancel" onClick={handleClose} variant="contained" />
        <StyledButton
          buttonType="save"
          onClick={handleAddData}
          variant="contained"
          color="primary"
          sx={{ fontWeight: "bold" }}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
